<template>
    <cadastro-simples-list
        endpoint="pais"
        rota-base="/admin/pais"
        titulo="PAÍSES"
        titulo-singular="País"
        :colunas-extras='[
            { campo: "nacionalidade", label: "Nacionalidade", tipo: "string" },
            { campo: "ddi", label: "DDI", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
